<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/oPS48N/tc-custom/9781429947435.jpg?1722312425264" alt="This image is the cover for the book Lost Prince"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lost Prince
      </h1>
      <p class="bookDescription body article font2">
        <p>Edward Lazellari brings you <i>The Lost Prince</i>, and the race to find the missing prince is on . . .<br/><br/>In Lazellari's debut fantasy, <i>Awakenings, </i>New York City cop Cal MacDonnell and photographer Seth Raincrest found themselves stalked by otherworldly beings intent on killing them. The two had to accept the aid of a mysterious woman to unlock their hidden pasts, and what they discovered changed their lives.<br/><br/>Everything they knew about their lives was an illusion. They had in fact travelled to our dimension from the medieval reality of Aandor to hide their infant prince from assassins, but upon arriving, a freak mishap wiped their memories. Cal, Seth, and the rest of their party were incapacitated, and the infant prince was lost.<br/><br/>Thirteen years later, that prince, Daniel Hauer, is unaware of his origins--or that he has become the prize in a race between two powerful opposing factions. Cal and Seth's group want to keep Daniel safe. The other wants Daniel dead—by any means necessary.<br/><br/>From the streets of New York City to the back roads of rural North Carolina, the search for the prince sets powerful forces against each other in a do-or-die battle for the rule of the kingdom of Aandor.<br/><br/>Against a backdrop of murder, magic, and mayhem on the streets of New York City, victory goes to the swiftest and the truest of hearts.<br/>"Combines crossover fantasy in the style of Charles de Lint and Mercedes Lackey with urban fantasy reminiscent of Jim Butcher in a hard knocks action tale."—<i>Library Journal </i>on <i>Awakenings</i><br/><br/><br/><br/>At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Edward Lazellari
      </h2>
      
      <p class="authorDescription body article">EDWARD LAZELLARI's short story "The Date" was published by <I>Playboy</I> magazine. He has worked as a writer, illustrator, and graphic artist, doing projects for Marvel Entertainment and DC Comics. Lazellari lives in Jersey City, New Jersey.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?31efdb3b